import React from 'react';

import {getLocalizedStrings} from '@/services/localization/localizationService';

import HomePageForYouContainer from './HomePageForYouContainer/HomePageForYouContainer';

const HomePageLeviaItem = (props) => {
    const {banner, promotedBadgeType, isGradient} = props;
    const {
        titleKey,
        descriptionKey,
        promotionKey,
        imageMedia,
        isDarkBannerText,
        amplitudeTrackingValue,
        action,
        actionAriaLabelKey,
    } = banner;
    const localizedStrings = getLocalizedStrings();

    return (
        <HomePageForYouContainer
            externalLink={action}
            imageMedia={imageMedia}
            isDarkText={isDarkBannerText}
            promotedBadgeType={promotedBadgeType}
            badgeText={localizedStrings[promotionKey]}
            titleText={localizedStrings[titleKey]}
            descriptionText={localizedStrings[descriptionKey]}
            amplitudeTrackingValue={amplitudeTrackingValue}
            linearGradient={isGradient}
            ariaLabelKey={actionAriaLabelKey}
            className='flex-col-reverse'
        />
    );
};

export default HomePageLeviaItem;
